import React from "react";
import { Link } from "react-router-dom";

const Logo: React.FC<{ classes?: string; spanClass?: string }> = ({
  classes,
  spanClass,
}) => {
  return (
    <Link className={classes} to="/">
      <span className={spanClass}>Happy</span> Food
    </Link>
  );
};
export default Logo;
